/* eslint-disable @typescript-eslint/no-var-requires */
// import TopBar2 from '@/components/Layout/TopBar2';

import useQueries from '@/hooks/useQueries';
import * as React from 'react';

import { useState } from 'react';
// import AddEmr from './components/AddEmr';
// import CreateEMR from '@/screens/PHR/components/CreateEMR';
import Timeline from '@/screens/Timeline';
import BodyScreen from '@/screens/BodyScreen';
// import PHRHeader from '@/screens/PHR/components/PHRHeader';
import PHRSidebar from '@/screens/PHR/components/PHRSidebar';

export interface IPHRScreenProps {}
export const SideContext = React.createContext({
  isCollapsed: false,
});

export default function PHRScreen(props: IPHRScreenProps) {
  const [queries] = useQueries();
  const { tab = 'list' } = queries;
  const [collapsed, setCollapsed] = useState<boolean>(false);

  React.useEffect(() => {
    setCollapsed(tab !== 'list');
  }, [tab]);

  return (
    <>
      <SideContext.Provider value={{ isCollapsed: collapsed }}>
        <div className="flex w-full h-full">
          <PHRSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
          <div className="h-full flex flex-col w-full">
            {/* <PHRHeader tab={tab} /> */}

            <div className="p-2 flex-grow h-full">
              <div className="relative w-full h-full">
                {tab === 'list' ? <BodyScreen /> : tab === 'timeline' ? <Timeline /> : ''}
              </div>
            </div>
          </div>
        </div>
      </SideContext.Provider>
    </>
  );
}
